import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { breadcrumbSchema, webPageSchema } from '../lib/seo';
import { Button } from '../components/ui/button';

export default function InsightsPage() {
  const path = '/insights';
  const title = 'Insights — Founder-Led Sales, Sales Function Design & Startup Sales | Founder Growth Collective';
  const description = 'Insights from Founder Growth Collective on founder-led sales, sales function design, sales hiring and building repeatable revenue for funded, founder-led startups.';
  const bc = [{ name: 'Home', path: '/' }, { name: 'Insights', path }];
  const schemas = [
    webPageSchema({ path, name: title, description }),
    breadcrumbSchema(bc),
  ];

  const CATEGORIES = [
    'Founder-led sales',
    'First sales hire',
    'Startup sales processes',
    'Sales team structure',
    'Sales playbooks',
    'Sales onboarding',
    'Sales leadership',
    'Post-funding sales strategy',
  ];

  return (
    <div className="bg-[#EBE4DE] text-[#2E2C28] min-h-screen">
      <SEO title={title} description={description} path={path} schemas={schemas} />
      <Navbar />
      <main className="pt-36 pb-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={bc} />

          <header className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-4">
              <p className="sec-num text-sm tracking-[0.3em] uppercase">/ Insights</p>
            </div>
            <div className="lg:col-span-8">
              <h1 className="font-serif text-[40px] sm:text-[52px] lg:text-[64px] leading-[1.02] tracking-[-0.015em] text-[#2E2C28] font-light">
                Founder-focused perspectives, <span className="italic text-[#B5876C]">coming soon.</span>
              </h1>
              <p className="mt-8 text-lg text-[#4a463f] font-light leading-relaxed max-w-2xl">
                Hannah’s field notes on scaling beyond founder-led sales — practical for funded founders, not theoretical for consultants.
              </p>
            </div>
          </header>

          <section aria-labelledby="themes" className="mt-20 border-t border-[#d9d2ca] pt-16">
            <h2 id="themes" className="font-serif text-2xl lg:text-3xl text-[#2E2C28] font-light mb-8">Coming themes</h2>
            <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {CATEGORIES.map(c => (
                <li key={c} className="border border-[#d9d2ca] p-5">
                  <p className="font-serif text-lg text-[#2E2C28] font-light leading-tight">{c}</p>
                </li>
              ))}
            </ul>
          </section>

          <div className="mt-16 flex flex-wrap gap-4">
            <Button asChild className="bg-[#2E2C28] hover:bg-[#B5876C] text-[#EBE4DE] rounded-none h-14 px-8 text-[12px] tracking-[0.2em] uppercase">
              <Link to="/founder-led-sales" className="inline-flex items-center gap-3">Read: Founder-Led Sales <ArrowUpRight size={16} strokeWidth={1.5} /></Link>
            </Button>
            <Button asChild variant="outline" className="border-[#B5876C]/40 text-[#2E2C28] hover:bg-[#B5876C] hover:text-[#EBE4DE] rounded-none h-14 px-8 text-[12px] tracking-[0.2em] uppercase">
              <Link to="/contact">Book a Discovery Call</Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
